import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Star, Users } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-[#0a1f44] text-white overflow-hidden pt-10 pb-12 md:pt-24 md:pb-32 px-4 md:px-8" data-id="element-117">
      {/* Background subtle glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-blue-900/20 blur-3xl pointer-events-none" data-id="element-118" />

      <div className="max-w-3xl mx-auto flex flex-col items-center text-center space-y-5 md:space-y-8 relative z-10" data-id="element-119">
        <div className="inline-flex items-center space-x-2 bg-blue-900/50 border border-blue-800/50 rounded-full px-3 py-1 md:px-4 md:py-1.5 text-xs md:text-sm font-medium text-blue-200 shadow-sm" data-id="element-120">
          <span className="text-lg md:text-xl" data-id="element-121">🧒</span>
          <span className="md:text-xs tracking-wide uppercase text-[8px]" data-id="element-122">
            Sistema N°1 para Psiquiatras Infantojuveniles de Argentina
          </span>
        </div>

        <h1 className="text-[26px] leading-tight md:text-4xl lg:text-5xl font-extrabold text-balance drop-shadow-sm" data-id="element-123">
          Matrícula Blindada en Psiquiatría Infantojuvenil
        </h1>

        <div className="relative flex justify-center items-center w-full py-2 md:py-4" data-id="element-124">
          <motion.div animate={{
          y: [-8, 8, -8]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} className="relative w-4/5 max-w-[400px]" data-id="element-125">
            <img src="https://cdn.magicpatterns.com/uploads/eHkWXPKnAbN2fjFQQuB2A8/mockup_psiquiatria_infantojuvenil-Photoroom.png" alt="Megapack Psiquiatría Infantojuvenil PRO" className="w-full h-auto object-contain drop-shadow-2xl" loading="eager" data-id="element-126" />
          </motion.div>
        </div>

        <div className="space-y-3 md:space-y-4 w-full" data-id="element-127">
          <p className="md:text-lg text-amber-400 font-semibold tracking-wide text-[12px]" data-id="element-128">
            6 Tomos + 6 Bonos — PDF Digital · Acceso Inmediato
          </p>
          <p className="text-[14px] md:text-base text-blue-100/90 leading-relaxed max-w-xl mx-auto text-balance" data-id="element-129">
            Protocolos, plantillas legales y herramientas clínicas para
            enfrentar cualquier situación con niños y adolescentes. Sin
            improvisar. Sin exponer tu matrícula.
          </p>
        </div>

        <div className="w-full sm:w-auto pt-2 md:pt-4" data-id="element-130">
          <motion.button onClick={scrollToPricing} animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          repeat: Infinity,
          duration: 3,
          ease: 'easeInOut'
        }} className="w-full sm:w-auto bg-orange-600 hover:bg-orange-500 text-white font-bold text-[15px] md:text-lg py-3.5 md:py-4 px-8 rounded-xl shadow-[0_0_20px_rgba(234,88,12,0.4)] transition-colors min-h-[52px]" data-id="element-131">
            💥 QUIERO MI MEGAPACK AHORA
          </motion.button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 pt-2 text-[12px] md:text-sm text-blue-200 font-medium" data-id="element-132">
          <div className="flex items-center gap-1.5 bg-blue-900/30 px-2.5 py-1 rounded-md" data-id="element-133">
            <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-emerald-400" data-id="element-134" />
            <span data-id="element-135">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5 bg-blue-900/30 px-2.5 py-1 rounded-md" data-id="element-136">
            <Users className="w-3.5 h-3.5 md:w-4 md:h-4 text-blue-400" data-id="element-137" />
            <span data-id="element-138">+800 Profesionales</span>
          </div>
          <div className="flex items-center gap-1.5 bg-blue-900/30 px-2.5 py-1 rounded-md" data-id="element-139">
            <Star className="w-3.5 h-3.5 md:w-4 md:h-4 text-amber-400 fill-amber-400" data-id="element-140" />
            <span data-id="element-141">4.9 Rating</span>
          </div>
        </div>
      </div>
    </section>;
}